/**
 * Loading text constants for spinners and async UI states.
 */

export class LoadingText {
    public static LOADING = "Loading...";
}
